<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ImageAudioVideo from '../../bubble/ImageAudioVideo.vue';
import IconRightArrowLong from '../icons/IconRightArrowLong.vue';

import type { IOrderItem, IOrderMessage } from './types';

const props = defineProps<{
  list: IOrderItem[];
  onViewMore: () => void;
  labels?: IOrderMessage['labels'];
}>();

const { t } = useI18n();

const { list, onViewMore, labels } = props ?? {};

const _list = list ?? [];
const showList = _list.slice(0, 3);
const hasMore = _list.length > showList.length;

const getAttachment = (item: IOrderItem) => {
  return {
    file_type: 'image',
    data_url: item.coverImage,
    height: 86,
  };
};

const viewMoreLabel =
  labels?.viewMore ?? t('CONVERSATION.CARD_MESSAGE.ORDER.VIEW_MORE');
</script>

<template>
  <div class="order-detail-list">
    <div
      v-for="item in showList"
      :key="item.goodsId"
      class="order-detail-item flex"
    >
      <ImageAudioVideo :attachment="getAttachment(item)" />
      <div class="count-wrapper">
        <div class="count">x{{ item.count }}</div>
      </div>
    </div>
    <div
      v-if="hasMore"
      class="order-detail-item flex view-more"
      @click="onViewMore"
    >
      <IconRightArrowLong />
      <div>{{ viewMoreLabel }}</div>
    </div>
  </div>
</template>

<style lang="scss">
.card-message-wrapper[dir='rtl'] {
  .view-more svg {
    transform: rotate(180deg);
  }
}
</style>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-detail-list {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 86px;

  .order-detail-item {
    height: 100%;
  }

  .order-detail-item {
    position: relative;

    .count-wrapper {
      position: absolute;
      bottom: 10px;
      width: 100%;
      height: 22px;
    }

    .count {
      margin: 0 auto;
      height: 22px;
      width: 22px;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 50%;
      color: #fff;
      font-size: 13px;
      text-align: center;
    }
  }

  .view-more {
    height: 100%;
    aspect-ratio: 3/4;
    flex-direction: column;
    gap: 5px;
    background-color: #f5f5f5;
    cursor: pointer;

    div {
      width: 28px;
      line-height: 14px;
      white-space: wrap;
      overflow: unset;
      text-overflow: unset;
    }
  }
}

.order-detail-list:has(.view-more) {
  justify-content: space-between;
}
</style>
